<ul class="sessions">
  @for (h of listDisplay; track h; let i = $index) {
    <li>
      <div class="flex">
        <div>
          <div class="time">
            {{h.date | date:'M/d/yyyy'}}
            @if (h.harvestAtEnd) {
              <mat-icon class="harvest-at-end">content_cut</mat-icon>
            }
          </div>
          <p>
            {{h.description}}
          </p>
        </div>
      </div>
    </li>
  }
</ul>

<!-- <app-timeline [dataList]="timelineData"></app-timeline> -->
